

import Home from "./Home";
import Products from './Products';
import Services from './Services'
import Contact from './Contact';
import './App.css';
import "./style.css"
import Container from 'react-bootstrap/Container';
import NavbarComponent from './NavbarCOmponent';
import ScrollToTop from "react-scroll-to-top";


import { useState } from 'react'

function App() {
  
  const [language, setLanguage] = useState("true")
  let CompanyFirstName = "Stock";
let CompanyLastName = "Direct";
  
  return (
    <div className="app-background">

    <Container >

      <NavbarComponent CompanyFirstName={CompanyFirstName} CompanyLastName={CompanyLastName} language={language} setLanguage={setLanguage}/>  
        
        <Home CompanyFirstName={CompanyFirstName}
          CompanyLastName={CompanyLastName}
          language={language} />
  
        <Products language={language}  />
        <Services language={language} />
        <Contact language={language}/>
        <ScrollToTop scrollButton  smooth color="red" style={{backgroundColor:"rgba(84, 82, 82, 0.42)",borderRadius:"50%"}}/>
    </Container>

</div>
  );
}
export default App;
